export default "__VITE_ASSET__CIsgI7it__"